import React, { Component, Fragment } from "react";
import { PermissionServices } from "../../services";
//components
import PageHeader from "../../components/Page/PageHeader/PageHeader";
import Field from "../../components/Common/Field/Field";
import Button from "../../components/Buttons/Button";

class PermissionRole extends Component {
  state = {
    action: "",
    _id: "",
    disabled: false,
    roleName: "",
    description: ""
  };

  componentWillMount() {
    let { action, _id } = this.props.location.state;
    if (action == "add") {
    }
    if (action == "view" || action == "edit") {
    }
    if (action == "view") {
      this.setState({
        disabled: true
      });
    }

    if (action === "edit" || action === "view") {
      PermissionServices.getRole(_id)
        .then(response => {
          if (response.status === 200) {
            this.setState({
              roleName: response.text.data.roleName,
              description: response.text.data.description
            });
          }
          else if(response.status == 401){
            this.props.unauthorisedFunc()
          }
          else{
            this.props.getalertMessage('error',response.text.message)
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()));
    }

    this.setState({ action, _id });
  }

  createRole = () => {
    if (this.state.action === "add") {
      PermissionServices.createRole(this.state.roleName, this.state.description)
        .then(response => {
          if (response.status === 200) {
            this.props.getalertMessage("success", response.text.message);
            this.setState({
              roleName: "",
              description: ""
            });
          } else if (response.status == 401) {
            this.props.unauthorisedFunc();
          } else {
            this.props.getalertMessage("error", response.text.message);
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()));
    } else if (this.state.action === "edit") {
      PermissionServices.editRole(
        this.state._id,
        this.state.roleName,
        this.state.description
      )
        .then(response => {
          if (response.status === 200) {
            this.props.getalertMessage("success", response.text.message);
            this.setState({
              roleName: "",
              description: ""
            });
          } else if (response.status == 401) {
            this.props.unauthorisedFunc();
          } else {
            this.props.getalertMessage("error", response.text.message);
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()));
    }
  };

  render() {
    const { roleName, description } = this.state;
    return (
      <Fragment>
        <div class="right-section bg-white">
          <div class="row nopadding ">
            <div class="col-md-12 nopadding">
              <PageHeader header={"Role"} history={this.props.history} />
              <div class="col-md-6 col-md-offset-3" style={{ marginTop: "2%" }}>
                <div class="col-md-12">
                  <Field
                    isFormGroup={true}
                    inputType="text"
                    inputName={`roleName`}
                    value={roleName}
                    label={"Role Name"}
                    onChange={(name, value) => this.setState({ [name]: value })}
                    disabled={this.state.disabled}
                  />
                </div>
                <div class="col-md-12">
                  <Field
                    isFormGroup={true}
                    inputType="textarea"
                    inputName={`description`}
                    value={description}
                    label={"Description"}
                    onChange={(name, value) => this.setState({ [name]: value })}
                    disabled={this.state.disabled}
                  />
                </div>
                <div className="col-md-12 text-center profile-btn">
                  {!this.state.disabled && (
                    <Button
                      buttonType="save"
                      buttonName="save"
                      onClick={this.createRole}
                    />
                  )}
                  <Button
                    history={this.props.history}
                    buttonType="cancel"
                    buttonName="Cancel"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PermissionRole;



// WEBPACK FOOTER //
// ./src/pages/PermissionRole/page.js